import { jsx, jsxs } from "react/jsx-runtime";
import {
  Autocomplete,
  Box,
  ListItem,
  ListItemButton,
  ListItemText,
  svgIconClasses,
  TextField
} from "@mui/material";
import { useEffect, useMemo, useRef } from "react";
function SelectWithPreview(props) {
  const { options, label, value, setField, iconPosition } = props;
  const rOptions = useRef(options);
  useEffect(() => void (rOptions.current = options));
  const currentValue = useMemo(() => rOptions.current.find((opt) => opt.value === value), [value]);
  return /* @__PURE__ */ jsx(
    Autocomplete,
    {
      "data-testid": "TidalControlsSelect",
      fullWidth: true,
      getOptionLabel: (option) => option.value ?? "",
      onChange: (_, nextValue) => {
        if (!nextValue) return;
        setField(label, nextValue.value);
      },
      options,
      renderInput: (params) => {
        let adornment = {};
        if (currentValue) {
          const { icon } = currentValue;
          const key = iconPosition === "end" ? "endAdornment" : "startAdornment";
          adornment = { [key]: icon };
        }
        return /* @__PURE__ */ jsx(
          TextField,
          {
            ...params,
            slotProps: {
              input: { ...params.InputProps, ...adornment }
            }
          }
        );
      },
      renderOption: (props2, option) => /* @__PURE__ */ jsx(ListItem, { ...props2, disableGutters: true, disablePadding: true, sx: { padding: 0 }, children: /* @__PURE__ */ jsxs(ListItemButton, { disableGutters: true, disableRipple: true, sx: { padding: 0, pointerEvents: "none" }, children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              flexShrink: 0,
              mr: 2,
              [`& .${svgIconClasses.root}`]: {
                display: "block"
              }
            },
            children: option.icon
          }
        ),
        /* @__PURE__ */ jsx(ListItemText, { sx: { flexGrow: 1 }, children: option.value })
      ] }) }),
      size: "small",
      value: currentValue
    }
  );
}
export {
  SelectWithPreview
};
//# sourceMappingURL=SelectWithPreview.js.map
